import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAuthenticated } from "../helpers/checkAuthentication"
const ProtectedRoute = () => {

  const isAuthenticatedResult = useSelector((state) => isAuthenticated(state));

  return isAuthenticatedResult ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
